// Import template definitions instead of SVGs and constants
import MonochromeTechTemplate from './definitions/Triangular/MonochromeTriangularTemplate';
import NavyTriangularTemplate from './definitions/Triangular/NavyTriangularTemplate';
import BlueTriangularTemplate from './definitions/Triangular/BlueTriangularTemplate';
import GreenTriangularTemplate from './definitions/Triangular/GreenTriangularTemplate';
import OrangeTriangularTemplate from './definitions/Triangular/OrangeTriangularTemplate';
import TealTriangularTemplate from './definitions/Triangular/TealTriangularTemplate';
import YellowTriangularTemplate from './definitions/Triangular/YellowTriangularTemplate';
import BurgundyTriangularTemplate from './definitions/Triangular/BurgundyTriangularTemplate';
import MonochromeGeometricTemplate from './definitions/Geometric/MonochromeGeometricTemplate';
import NavyGeometricTemplate from './definitions/Geometric/NavyGeometricTemplate';
import BlueGeometricTemplate from './definitions/Geometric/BlueGeometricTemplate';
import GreenGeometricTemplate from './definitions/Geometric/GreenGeometricTemplate';
import OrangeGeometricTemplate from './definitions/Geometric/OrangeGeometricTemplate';
import TealGeometricTemplate from './definitions/Geometric/TealGeometricTemplate';
import YellowGeometricTemplate from './definitions/Geometric/YellowGeometricTemplate';
import BurgundyGeometricTemplate from './definitions/Geometric/BurgundyGeometricTemplate';
import NavySidebarRightTemplate from './definitions/SidebarRightClassic/NavySidebarRightTemplate';
import BlueSidebarRightTemplate from './definitions/SidebarRightClassic/BlueSidebarRightTemplate';
import MonochromeSidebarRightTemplate from './definitions/SidebarRightClassic/MonochromeSidebarRightTemplate';
import YellowSidebarRightTemplate from './definitions/SidebarRightClassic/YellowSidebarRightTemplate';
import TealSidebarRightTemplate from './definitions/SidebarRightClassic/TealSidebarRightTemplate';
import OrangeSidebarRightTemplate from './definitions/SidebarRightClassic/OrangeSidebarRightTemplate';
import GreenSidebarRightTemplate from './definitions/SidebarRightClassic/GreenSidebarRightTemplate';
import NavySidebarLeftTemplate from './definitions/SidebarLeftClassic/NavySidebarLeftTemplate';
import BlueSidebarLeftTemplate from './definitions/SidebarLeftClassic/BlueSidebarLeftTemplate';
import MonochromeSidebarLeftTemplate from './definitions/SidebarLeftClassic/MonochromeSidebarLeftTemplate';
import YellowSidebarLeftTemplate from './definitions/SidebarLeftClassic/YellowSidebarLeftTemplate';
import TealSidebarLeftTemplate from './definitions/SidebarLeftClassic/TealSidebarLeftTemplate';
import OrangeSidebarLeftTemplate from './definitions/SidebarLeftClassic/OrangeSidebarLeftTemplate';
import GreenSidebarLeftTemplate from './definitions/SidebarLeftClassic/GreenSidebarLeftTemplate';
import MonochromeClassicCenteredTimelineTemplate from './definitions/ClassicCenteredTimeline/MonochromeClassicCenteredTimeline';
import BlueClassicCenteredTimelineTemplate from './definitions/ClassicCenteredTimeline/BlueClassicCenteredTimeline';
import GreenClassicCenteredTimelineTemplate from './definitions/ClassicCenteredTimeline/GreenClassicCenteredTimeline';
import NavyClassicCenteredTimelineTemplate from './definitions/ClassicCenteredTimeline/NavyClassicCenteredTimeline';
import OrangeClassicCenteredTimelineTemplate from './definitions/ClassicCenteredTimeline/OrangeClassicCenteredTimeline';
import TealClassicCenteredTimelineTemplate from './definitions/ClassicCenteredTimeline/TealClassicCenteredTimeline';
import YellowClassicCenteredTimelineTemplate from './definitions/ClassicCenteredTimeline/YellowClassicCenteredTimeline';
import GreenSidebarLeftModernTemplate from './definitions/SidebarLeftModern/GreenSidebarLeftModernTemplate';
import BlueSidebarLeftModernTemplate from './definitions/SidebarLeftModern/BlueSidebarLeftModernTemplate';
import NavySidebarLeftModernTemplate from './definitions/SidebarLeftModern/NavySidebarLeftModernTemplate';
import YellowSidebarLeftModernTemplate from './definitions/SidebarLeftModern/YellowSidebarLeftModernTemplate';
import TealSidebarLeftModernTemplate from './definitions/SidebarLeftModern/TealSidebarLeftModernTemplate';
import OrangeSidebarLeftModernTemplate from './definitions/SidebarLeftModern/OrangeSidebarLeftModernTemplate';
import MonochromeSidebarLeftModernTemplate from './definitions/SidebarLeftModern/MonochromeSidebarLeftModernTemplate';
import GreenSidebarLeftModernLightTemplate from './definitions/SidebarLeftModern/GreenSidebarLeftModernLightTemplate';
import BlueSidebarLeftModernLightTemplate from './definitions/SidebarLeftModern/BlueSidebarLeftModernLightTemplate';
import NavySidebarLeftModernLightTemplate from './definitions/SidebarLeftModern/NavySidebarLeftModernLightTemplate';
import YellowSidebarLeftModernLightTemplate from './definitions/SidebarLeftModern/YellowSidebarLeftModernLightTemplate';
import TealSidebarLeftModernLightTemplate from './definitions/SidebarLeftModern/TealSidebarLeftModernLightTemplate';
import OrangeSidebarLeftModernLightTemplate from './definitions/SidebarLeftModern/OrangeSidebarLeftModernLightTemplate';
import MonochromeSidebarLeftModernLightTemplate from './definitions/SidebarLeftModern/MonochromeSidebarLeftModernLightTemplate';
import GreenSidebarRightModernTemplate from './definitions/SidebarRightModern/GreenSidebarRightModernTemplate';
import BlueSidebarRightModernTemplate from './definitions/SidebarRightModern/BlueSidebarRightModernTemplate';
import NavySidebarRightModernTemplate from './definitions/SidebarRightModern/NavySidebarRightModernTemplate';
import YellowSidebarRightModernTemplate from './definitions/SidebarRightModern/YellowSidebarRightModernTemplate';
import TealSidebarRightModernTemplate from './definitions/SidebarRightModern/TealSidebarRightModernTemplate';
import OrangeSidebarRightModernTemplate from './definitions/SidebarRightModern/OrangeSidebarRightModernTemplate';
import MonochromeSidebarRightModernTemplate from './definitions/SidebarRightModern/MonochromeSidebarRightModernTemplate';
import GreenSidebarRightModernLightTemplate from './definitions/SidebarRightModern/GreenSidebarRightModernLightTemplate';
import BlueSidebarRightModernLightTemplate from './definitions/SidebarRightModern/BlueSidebarRightModernLightTemplate';
import NavySidebarRightModernLightTemplate from './definitions/SidebarRightModern/NavySidebarRightModernLightTemplate';
import YellowSidebarRightModernLightTemplate from './definitions/SidebarRightModern/YellowSidebarRightModernLightTemplate';
import TealSidebarRightModernLightTemplate from './definitions/SidebarRightModern/TealSidebarRightModernLightTemplate';
import OrangeSidebarRightModernLightTemplate from './definitions/SidebarRightModern/OrangeSidebarRightModernLightTemplate';
import MonochromeSidebarRightModernLightTemplate from './definitions/SidebarRightModern/MonochromeSidebarRightModernLightTemplate';
import BlueTopbarTemplate from './definitions/TopbarClassic/BlueTopbarTemplate';
import GreenTopbarTemplate from './definitions/TopbarClassic/GreenTopbarTemplate';
import MonochromeTopbarTemplate from './definitions/TopbarClassic/MonochromeTopbarTemplate';
import NavyTopbarTemplate from './definitions/TopbarClassic/NavyTopbarTemplate';
import OrangeTopbarTemplate from './definitions/TopbarClassic/OrangeTopbarTemplate';
import TealTopbarTemplate from './definitions/TopbarClassic/TealTopbarTemplate';
import YellowTopbarTemplate from './definitions/TopbarClassic/YellowTopbarTemplate';
import BlueTopbarModernTemplate from './definitions/TopbarModern/BlueTopbarModernTemplate';
import GreenTopbarModernTemplate from './definitions/TopbarModern/GreenTopbarModernTemplate';
import MonochromeTopbarModernTemplate from './definitions/TopbarModern/MonochromeTopbarModernTemplate';
import NavyTopbarModernTemplate from './definitions/TopbarModern/NavyTopbarModernTemplate';
import OrangeTopbarModernTemplate from './definitions/TopbarModern/OrangeTopbarModernTemplate';
import TealTopbarModernTemplate from './definitions/TopbarModern/TealTopbarModernTemplate';
import YellowTopbarModernTemplate from './definitions/TopbarModern/YellowTopbarModernTemplate';
import BlueTopbarModernLightTemplate from './definitions/TopbarModern/BlueTopbarModernLightTemplate';
import GreenTopbarModernLightTemplate from './definitions/TopbarModern/GreenTopbarModernLightTemplate';
import MonochromeTopbarModernLightTemplate from './definitions/TopbarModern/MonochromeTopbarModernLightTemplate';
import NavyTopbarModernLightTemplate from './definitions/TopbarModern/NavyTopbarModernLightTemplate';
import OrangeTopbarModernLightTemplate from './definitions/TopbarModern/OrangeTopbarModernLightTemplate';
import TealTopbarModernLightTemplate from './definitions/TopbarModern/TealTopbarModernLightTemplate';
import YellowTopbarModernLightTemplate from './definitions/TopbarModern/YellowTopbarModernLightTemplate';
// Add imports for future templates here
// import ModernBlueTemplate from './definitions/ModernBlueTemplate';

// Array containing all available templates by importing their definitions
const TEMPLATES = [

  MonochromeTechTemplate,
  BlueTriangularTemplate,
  NavyTriangularTemplate,
  GreenTriangularTemplate,
  OrangeTriangularTemplate,
  TealTriangularTemplate,
  YellowTriangularTemplate,
  BurgundyTriangularTemplate,
  MonochromeGeometricTemplate,
  BlueGeometricTemplate,
  NavyGeometricTemplate,
  GreenGeometricTemplate,
  OrangeGeometricTemplate,
  TealGeometricTemplate,
  YellowGeometricTemplate,
  BurgundyGeometricTemplate,
  MonochromeSidebarRightTemplate,
  BlueSidebarRightTemplate,
  NavySidebarRightTemplate,
  YellowSidebarRightTemplate,
  TealSidebarRightTemplate,
  OrangeSidebarRightTemplate,
  GreenSidebarRightTemplate,
  MonochromeSidebarLeftTemplate,
  BlueSidebarLeftTemplate,
  NavySidebarLeftTemplate,
  YellowSidebarLeftTemplate,
  TealSidebarLeftTemplate,
  OrangeSidebarLeftTemplate,
  GreenSidebarLeftTemplate,
  MonochromeClassicCenteredTimelineTemplate,
  BlueClassicCenteredTimelineTemplate,
  GreenClassicCenteredTimelineTemplate,
  NavyClassicCenteredTimelineTemplate,
  OrangeClassicCenteredTimelineTemplate,
  TealClassicCenteredTimelineTemplate,
  YellowClassicCenteredTimelineTemplate,
  GreenSidebarLeftModernTemplate,
  BlueSidebarLeftModernTemplate,
  NavySidebarLeftModernTemplate,
  YellowSidebarLeftModernTemplate,
  TealSidebarLeftModernTemplate,
  OrangeSidebarLeftModernTemplate,
  MonochromeSidebarLeftModernTemplate,
  GreenSidebarLeftModernLightTemplate,
  BlueSidebarLeftModernLightTemplate,
  NavySidebarLeftModernLightTemplate,
  YellowSidebarLeftModernLightTemplate,
  TealSidebarLeftModernLightTemplate,
  OrangeSidebarLeftModernLightTemplate,
  MonochromeSidebarLeftModernLightTemplate,
  GreenSidebarRightModernTemplate,
  BlueSidebarRightModernTemplate,
  NavySidebarRightModernTemplate,
  YellowSidebarRightModernTemplate,
  TealSidebarRightModernTemplate,
  OrangeSidebarRightModernTemplate,
  MonochromeSidebarRightModernTemplate,
  GreenSidebarRightModernLightTemplate,
  BlueSidebarRightModernLightTemplate,
  NavySidebarRightModernLightTemplate,
  YellowSidebarRightModernLightTemplate,
  TealSidebarRightModernLightTemplate,
  OrangeSidebarRightModernLightTemplate,
  MonochromeSidebarRightModernLightTemplate,
  BlueTopbarTemplate,
  GreenTopbarTemplate,
  MonochromeTopbarTemplate,
  NavyTopbarTemplate,
  OrangeTopbarTemplate,
  TealTopbarTemplate,
  YellowTopbarTemplate,
  BlueTopbarModernTemplate,
  GreenTopbarModernTemplate,
  MonochromeTopbarModernTemplate,
  NavyTopbarModernTemplate,
  OrangeTopbarModernTemplate,
  TealTopbarModernTemplate,
  YellowTopbarModernTemplate,
  BlueTopbarModernLightTemplate,
  GreenTopbarModernLightTemplate,
  MonochromeTopbarModernLightTemplate,
  NavyTopbarModernLightTemplate,
  OrangeTopbarModernLightTemplate,
  TealTopbarModernLightTemplate,
  YellowTopbarModernLightTemplate,
  // Add future imported templates here
  // ModernBlueTemplate,
];

/**
 * Retrieves all available templates.
 * @returns {Array<Object>} An array of template objects.
 */
export const getAllTemplates = () => {
  // Return a copy to prevent accidental modification of the original array? Optional.
  // return [...TEMPLATES];
  return TEMPLATES;
};

/**
 * Retrieves a specific template by its ID.
 * @param {string} id - The ID of the template to retrieve.
 * @returns {Object|null} The template object or null if not found.
 */
export const getTemplateById = (id) => {
  // Find template by ID (case-sensitive)
  return TEMPLATES.find(template => template.id === id) || null;
};

// Optional: Export the array itself if needed elsewhere, though functions are safer
// export { TEMPLATES };

export default {
  getAllTemplates,
  getTemplateById,
  // TEMPLATES // Optionally export the array directly
}; 